import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import configureStore from './store';
import {Provider} from 'react-redux';// very important to connect all the aplication

const store = configureStore(); // You can also pass in an initialState here
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/